import React, { forwardRef, useContext, useImperativeHandle, useState } from 'react'
import { ICellEditorParams } from 'ag-grid-community'
import { LabeledValue } from 'antd/lib/select'
import { UnspscCommoditySelector } from '../../../../common/components/UnspscCommoditySelector'
import { UnspscCommodity } from '../../../../api/gen/models'
import { EditingAgGridContext } from '../MarkupRules'

export const AgUnspscCommoditySelector = forwardRef<{}, ICellEditorParams>((params, ref) => {
  const [unspscCommodityCode, setUnspscCommodityCode] = useState<LabeledValue[]>(
    params.data.unspscCommodity?.map((i: UnspscCommodity) => ({
      value: i.commodity,
      label: i.commodityTitle,
    })) || [],
  )
  const { onChangeEditingItem, editingItem } = useContext(EditingAgGridContext)

  useImperativeHandle(ref, () => ({
    getValue: () => unspscCommodityCode,
  }))

  return (
    <UnspscCommoditySelector
      disabled={!!editingItem?.manufacturer?.length || !!editingItem?.marketBasket?.length}
      style={{
        visibility: !!editingItem?.manufacturer?.length || !!editingItem?.marketBasket?.length ? 'hidden' : 'visible',
      }}
      allowClear
      value={unspscCommodityCode}
      onChange={v => {
        onChangeEditingItem(prev => ({
          ...prev,
          unspsc: (v as LabeledValue[]).map((i: LabeledValue) => i.value as string),
          unspscCommodity: (v as LabeledValue[]).map((i: LabeledValue) => ({
            commodity: i.value as string,
            commodityTitle: i.label as string,
          })),
        }))
        setUnspscCommodityCode(v as LabeledValue[])
      }}
      mode="multiple"
      maxTagCount="responsive"
      placeholder="Select UNSPSC Commodity"
    />
  )
})
